var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconYoutube = function SvgIconYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M4.459 6.444a1.39 1.39 0 0 0-.946.953 22.3 22.3 0 0 0 0 9.206 1.39 1.39 0 0 0 .946.953 46.3 46.3 0 0 0 15.082 0 1.39 1.39 0 0 0 .946-.953c.64-3.035.64-6.17 0-9.206a1.39 1.39 0 0 0-.946-.953 46.3 46.3 0 0 0-15.082 0m-.19-.982a47.3 47.3 0 0 1 15.463 0l.05.011a2.39 2.39 0 0 1 1.68 1.701 23.3 23.3 0 0 1-.007 9.68 2.39 2.39 0 0 1-1.723 1.684 47.3 47.3 0 0 1-15.464 0l-.05-.011a2.39 2.39 0 0 1-1.68-1.7 23.3 23.3 0 0 1 .007-9.681 2.39 2.39 0 0 1 1.723-1.684m5.702 3.27a.5.5 0 0 1 .504.006l4.722 2.833a.5.5 0 0 1 0 .858l-4.722 2.833a.5.5 0 0 1-.757-.429V9.166a.5.5 0 0 1 .253-.435m.747 1.318v3.9l3.25-1.95z",
    clipRule: "evenodd"
  })));
};
export default SvgIconYoutube;